import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import NoResultsMessage from '../../../../components/NoResultsMessage';
import SearchSimpleTable from '../../../../components/search/SearchSimpleTable';
import { CypressIds } from '../../../../constants/cypressIds';
import noInsuredsImage from '../../../../noInsuredsImage.png';
import SearchBlueprintType from '../../../../types/SearchBlueprintType';
import InsuredRow from '../InsuredRow';

const SearchPanel = ({ searchBlueprint, viewOnly = false }) => {
  const filters = useSelector(searchBlueprint.selectQuickFilterOptions);

  const noResults = () => {
    const insuredStatusFilters = filters?.find(f => f.name === 'insuredStatus');
    const messageText = insuredStatusFilters?.selected.length === 1 ? (insuredStatusFilters.selected[0].text).toLowerCase()
      : '';

    return (
      <NoResultsMessage
        altTag="No Records"
        image={noInsuredsImage}
        message={`There are no ${messageText} records on this project.`}
      />
    );
  };

  const mapper = ({ id, status, insured, job, insuranceRequirement, recordIntegrations }) => {
    const row = {
      id: insured.id,
      externalId: insured.externalId,
      companyName: insured.companyName,
      guarantorName: insured.guarantorName,
      legalName: insured.legalName,
      email: insured.email,
      cc: insured?.cc,
      projectId: job.id,
      requirementId: id,
      contractNumber: insuranceRequirement?.contractNumber,
      overallStatus: insured.overallStatus,
      requirementDescription: insuranceRequirement?.description,
      requirementEmail: insuranceRequirement?.contact?.email,
      requirementCc: insuranceRequirement?.contact?.cc,
      cypressId: CypressIds.projectDetailsRecordRowByName(insured.companyName),
      status,
      recordIntegrations
    };

    return <InsuredRow insured={row} key={insured.id} viewOnly={viewOnly} />;
  };

  return (
    <SearchSimpleTable
      dataMapper={mapper}
      height="77vh"
      minHeight="300px"
      noResultsComponent={noResults}
      searchBlueprint={searchBlueprint}
    />
  );
};

SearchPanel.propTypes = { searchBlueprint: SearchBlueprintType, viewOnly: PropTypes.bool };

export default SearchPanel;
